// extracted by mini-css-extract-plugin
export default {"card":"History_card__gM4Wo","transaction":"History_transaction__BW1ed"};